module.exports = __webpack_public_path__ + "img/14.45a5e319.jpg";